'use client';

import type { PropsWithChildren } from 'react';

import { Typography } from '@ui/uikit/components/common/Typography';

import styles from './HeadingSection.module.scss';

interface HeadingSectionProps {
  title: string;
  description: string;
  headlineComponent?: 'h3' | 'h6';
}

export const HeadingSection = ({
  title,
  description,
  headlineComponent = 'h3',
  children,
}: PropsWithChildren<HeadingSectionProps>) => {
  return (
    <section className={styles.container}>
      <div className={styles.title}>
        <Typography variant="h1" component={headlineComponent} textAlign="center">
          {title}
        </Typography>
        <Typography variant="caption-m" textAlign="center">
          {description}
        </Typography>
      </div>
      {children}
    </section>
  );
};
